import { render } from "./App.vue?vue&type=template&id=4a4fe1c6"
const script = {}

import "./App.vue?vue&type=style&index=0&id=4a4fe1c6&lang=scss"

import exportComponent from "D:\\work\\粤智康医药网\\guanwang\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__